<script setup lang="ts">
import AppShell from "../Layout/AppShell.vue"
import BOMForm from "./components/BOMForm.vue"

defineProps<{
  bill_of_material: {
    id?: number | null
    company_id: number | ""
    product_id: number | ""
    items: Array<{
      id?: number | null
      component_id: number | ""
      quantity: string
    }>
  }
  companies: Array<{ id: number; name: string }>
  parent_products: Array<{ label: string; value: number }>
  components: Array<{ label: string; value: number }>
  errors?: Record<string, string[]>
}>()
</script>

<template>
  <AppShell>
    <BOMForm
      mode="create"
      title="Nova composicao do produto"
      subtitle="Cadastre os componentes e quantidades para produzir uma unidade do produto pai."
      :bill-of-material="bill_of_material"
      :companies="companies"
      :parent-products="parent_products"
      :components="components"
      :errors="errors"
    />
  </AppShell>
</template>

